// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"7eadf8ea","67":"9ec4dc56","444":"84552c27","596":"55f84367","750":"d35b8857","974":"244ac40f","986":"1b6c9b3a"}[chunkId] + ".chunk.js";
};